// extracted by mini-css-extract-plugin
export default {"header":"styles_header__DmAfP","button":"styles_button__RT3fU"};